import React = require('react');
import {IQuestion} from './models';
import {Choice} from "./Choice";
import {FormGroup} from './FormGroup';
import {IFilterChoices} from "./models";
import {IChoice} from "./models";
import Immutable = require('immutable');
import {AsyncPost} from "./utils";
import {AsyncPostStatus} from "./utils";
import {Dictionary} from "./utils";
import {validateAddressFormData} from "./validation";

declare var ga, $;

interface Properties {
    postData: AsyncPost<any,any>
}

interface Callbacks {
    onSubmit: (formData: Object) => void    // Triggered when the user submits the form & data pass validation checks
}

interface Props extends Properties, Callbacks {}

interface State {
    validationErrors: Dictionary<string[]>
}

export class AddressForm extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            validationErrors: {}
        }
    }

    handleSubmit(event) {

        event.preventDefault();

        if (this.props.postData.status == AsyncPostStatus.POSTING) {
            // The form is currently being posted so we don't do anything
            return;
        }

        var formData = Immutable.List( $(this.refs["contactform"]).serializeArray() )
            .reduce( (map, obj: any) => map.set(obj.name, obj.value), Immutable.Map() )
            .set('country', 'South Africa')
            .toJS();

        // If the checkbox was not ticked, the quoteMeFirst property will not be there so we are adding it
        if (!formData.quoteMeFirst) {
            formData.quoteMeFirst = false;
        }

        var errors = validateAddressFormData(formData);

        this.setState({
            validationErrors: errors
        });

        if (Immutable.Map(errors).size > 0) {
            ga('send', 'event', 'Wizard', 'address-form-validation-error');
            // There are some validation errors so we don't proceed
        } else {
            this.props.onSubmit(formData);
        }
    }

    render() {
        var submitButton;
        if (this.props.postData.status == AsyncPostStatus.POSTING) {
            submitButton = <button type="submit" className="cc-contact-form__submit-btn btn btn-success btn-lg btn-cc-green disabled" onClick={this.handleSubmit.bind(this)}>Submitting ...</button>
        } else {
            submitButton = <button type="submit" className="cc-contact-form__submit-btn btn btn-success btn-lg btn-cc-green" onClick={this.handleSubmit.bind(this)}>Submit</button>
        }

        return <div className="cc-contact-form">
            <form ref="contactform">
                <div className="row">

                    <div className="cc-contact-form__right-side col-xs-12">
                        <FormGroup errors={this.state.validationErrors['address']}>
                            <div>
                                <label htmlFor="inputAreaCode">Street</label>
                            </div>
                            <div className="row">
                                <div className="col-xs-4 col-padding-right-sm">
                                    <input
                                        type="text"
                                        name="streetNumber"
                                        className="form-control"
                                        id="inputAreaCode"
                                        placeholder="Street #"
                                    />
                                </div>
                                <div className="col-xs-8 col-padding-left-sm">
                                    <input
                                        type="text"
                                        name="streetName"
                                        className="form-control"
                                        id="inputContactNumber"
                                        placeholder="Street Name"
                                    />
                                </div>
                            </div>
                        </FormGroup>
                        <FormGroup errors={this.state.validationErrors['city']}>
                            <label htmlFor="inputCity">City</label>
                            <input
                                type="text"
                                name="city"
                                className="form-control"
                                id="inputCity"
                                placeholder="City"
                            />
                        </FormGroup>
                        <FormGroup errors={this.state.validationErrors['zipCode']}>
                            <label htmlFor="inputZIP">ZIP / Postal Code</label>
                            <input
                                type="text"
                                name="zipCode"
                                className="form-control"
                                id="inputZIP"
                                placeholder="ZIP / Postal Code"
                            />
                        </FormGroup>
                        <FormGroup errors={this.state.validationErrors['country']}>
                            <label htmlFor="inputCountry">Country</label>
                            <input type="text" name="country" className="form-control" id="inputCountry" placeholder="Country" value="South Africa" disabled={true}/>
                        </FormGroup>
                    </div>
                </div>

                <div className="row">
                    <div className="col-xs-12 text-center">
                        {submitButton}
                    </div>
                </div>
            </form>

        </div>;
    }
}
